import React, { useEffect, useState } from 'react'
import RenewalPeriodView from './components/RenewalPeriodView.jsx'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const RenewalPeriod = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    try {
      addToGoogleDataLayer('renewal-period', 'Renew your Vehicle Permit', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [])

  return isError ? <Error /> : <RenewalPeriodView setIsError={setIsError} />
}

export default withTranslation('common')(RenewalPeriod)
